import React from 'react'

import { Box } from 'system'
import { Subheading } from './Subheading'

const TableHeading = ({ children, ...props }) => (
  <Box as="th" display="table-cell" px={2} py={2} {...props}>
    <Subheading as="span" color="purple.50" lineHeight="solid" display="block">
      {children}
    </Subheading>
  </Box>
)

export const FieldsTable = ({ children, ...props }) => {
  return (
    <Box
      as="table"
      borderRadius={2}
      display="table"
      my={4}
      overflow="hidden"
      width={1}
      css={`
        box-shadow: 0 0 0 1px ${p => p.theme.colors.purple[90]};
      `}
      {...props}
    >
      <Box
        as="thead"
        bg="purple.100"
        borderBottom="1px solid"
        borderBottomColor="purple.90"
        display="table-header-group"
        gridColumnGap={4}
        gridTemplateColumns="2fr 1fr 6fr"
      >
        <TableHeading>Name</TableHeading>
        <TableHeading py={1}>Required?</TableHeading>
        <TableHeading>Description</TableHeading>
      </Box>
      {children}
    </Box>
  )
}

export default FieldsTable
